import { Routes } from '@angular/router';
import { permissionGuard } from './infrastructure/guards/permission.guard';
import { diagnosticsAccessGuard } from './infrastructure/guards/permission-with-feature-flag.guard';
import { Permissions } from './core/enums';
import { LoginComponent } from './features/login/login.component';
import { AuthCallbackComponent } from './features/auth/auth-callback.component';
import { ExternalLoginComponent } from './features/auth/external-login.component';
import { RequestsComponent } from './features/requests/requests.component';
import { RequestDetailsComponent } from './features/requests/request-details/request-details.component';
import { CompanyComponent } from './features/company/company.component';
import { AddCompanyComponent } from './features/company/add-company.component';
import { EditCompanyComponent } from './features/company/edit-company.component';
import { UsersComponent } from './features/users/users.component';
import { DiagnosticsComponent } from './features/diagnostics/diagnostics.component';
import { FileDetailsComponent } from './features/file-details/file-details.component';
import { MainLayoutComponent } from './shared/components/main-layout/main-layout.component';
import { authGuard } from './infrastructure/guards/auth.guard';
import { UnauthorizedComponent } from './features/unauthorized/unauthorized.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login' },
  },
  {
    path: 'auth/callback',
    component: AuthCallbackComponent,
    data: { title: 'Authentication' },
  },
  {
    path: 'login/external',
    component: ExternalLoginComponent,
    data: { title: 'External Sign In' },
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'requests',
        component: RequestsComponent,
        canActivate: [
          permissionGuard([
            Permissions.AccessRequestsListView4Customers,
            Permissions.AccessRequestsListView4Internals,
          ]),
        ],
        data: { title: 'Requests', breadcrumb: 'Requests' },
      },
      {
        path: 'requestDetails/:requestNumber',
        component: RequestDetailsComponent,
        canActivate: [
          permissionGuard([
            Permissions.AccessRequestsListView4Customers,
            Permissions.AccessRequestsListView4Internals,
          ]),
        ],
        data: {
          title: 'Request Details',
          breadcrumb: 'Request Details',
          breadcrumbParent: 'requests',
        },
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [
          permissionGuard([
            Permissions.AccessControlPanelUsersMenu,
            Permissions.AccessUserParentMenu,
          ]),
        ],
        data: { title: 'Users', breadcrumb: 'Users' },
      },
      {
        path: 'company',
        component: CompanyComponent,
        canActivate: [
          permissionGuard([Permissions.AccessControlPanelCompaniesMenu]),
        ],
        data: { title: 'Company', breadcrumb: 'Company' },
      },
      {
        path: 'company/add',
        component: AddCompanyComponent,
        canActivate: [
          permissionGuard([Permissions.AccessToAddOrEditCompanies]),
        ],
        data: {
          title: 'Add Company',
          breadcrumb: 'Add Company',
          breadcrumbParent: 'company',
        },
      },
      {
        path: 'company/edit/:id',
        component: EditCompanyComponent,
        canActivate: [
          permissionGuard([Permissions.AccessToAddOrEditCompanies]),
        ],
        data: {
          title: 'Edit Company',
          breadcrumb: 'Edit Company',
          breadcrumbParent: 'company',
        },
      },
      {
        path: 'diagnostics',
        component: DiagnosticsComponent,
        canActivate: [diagnosticsAccessGuard],
        data: { title: 'Diagnostics', breadcrumb: 'Diagnostics' },
      },
      {
        path: 'file-details',
        component: FileDetailsComponent,
        canActivate: [permissionGuard([Permissions.AccessToFileDetails])],
        data: {
          title: 'File Details',
          breadcrumb: 'File Details',
          breadcrumbParent: 'requests',
        },
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent,
        data: {
          title: 'Unauthorized',
          breadcrumb: 'Unauthorized',
        },
      },
    ],
  },
  // Fallback - redirect unknown routes to login
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
